
    <template>
      <section class="content element-doc">
        <h2>国际化</h2>
<h3>目前 Apex-UI 只做了中文和英文两种语言</h3>
<p>Apex-UI 组件内部默认使用中文，若希望使用其他语言，则需要进行多语言设置。以英文为例，在 main.js 中：</p>
<pre><code class="language-javascript">// 完整引入 Apex-UI
import Vue from 'vue'
import ApexUI from 'apex-ui-wh'
import locale from 'apex-ui-wh/lib/langEn'

Vue.use(ApexUI, { locale })
</code></pre>
<p>或</p>
<pre><code class="language-javascript">// 按需引入 Apex-UI
import Vue from 'vue'
import { Button, Select } from 'apex-ui-wh'
import lang from 'apex-ui-wh/lib/langEn'
import locale from 'apex-ui-wh/lib/locale'

// 设置语言
locale.use(lang)

// 引入组件
Vue.component(Button.name, Button)
Vue.component(Select.name, Select)
</code></pre>
<h2>兼容 <code>vue-i18n@6.x</code></h2>
<p>默认不支持 6.x 的 <code>vue-i18n</code>，你需要手动处理。</p>
<pre><code class="language-javascript">import Vue from 'vue'
import Apex-UI from 'apex-ui-wh'
import VueI18n from 'vue-i18n'
import enLocale from 'apex-ui-wh/lib/langEn'
import zhLocale from 'apex-ui-wh/lib/langZhCN'
import zhTWLocale from 'apex-ui-wh/lib/langZhTW'

Vue.use(VueI18n)

const messages = {
  en-US: {
    message: 'hello',
    ...enLocale // 或者用 Object.assign({ message: 'hello' }, enLocale)
  },
  zh: {
    message: '你好',
    ...zhLocale // 或者用 Object.assign({ message: '你好' }, zhLocale)
  }
}
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'en-US', // set locale
  messages, // set locale messages
})

Vue.use(Apex-UI, {
  i18n: (key, value) =&gt; i18n.t(key, value)
})

new Vue({ i18n }).$mount('#app')
</code></pre>
<h3>例子：中英文切换</h3>
<p>组件中英文切换显示</p>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;apex-button type=&quot;primary&quot; @click=&quot;handleSetLanguage&quot; style=&quot;margin-bottom: 10px&quot;&gt;切换中英文&lt;/apex-button&gt;
&lt;apex-button type=&quot;primary&quot; @click=&quot;handleSetLanguageTW&quot; style=&quot;margin-bottom: 10px;margin-left:50px;&quot;&gt;切換繁體&lt;/apex-button&gt;
&lt;apex-filter lang=&quot;en&quot; :query.sync=&quot;filterInfo.query&quot; :filter-list=&quot;filterInfo.list&quot; :list-type-info=&quot;listTypeInfo&quot; /&gt;

&lt;script&gt;
export default {
  data() {
    return {
      filterInfo: {
        query: {
          holdStatus: '',
          pol: '',
          pod: '',
          etd: '',
          eta: '',
          customer: '',
          hawbNo: '',
          warehouse: '',
          shipmentNo: ''
        },
        list: [
          { type: 'select', label: 'Hold Status', value: 'holdStatus', list: 'holdStatusList' },
          { type: 'input', label: 'POL', value: 'pol' },
          { type: 'input', label: 'POD', value: 'pod' },
          { type: 'date', label: 'ETD', value: 'etd', dateType: 'date' },
          { type: 'date', label: 'ETA', value: 'eta', dateType: 'datetime' },
          { type: 'select', label: 'Customer', value: 'customer', list: 'customerList' },
          { type: 'input', label: 'HAWB NO.', value: 'hawbNo' },
          { type: 'input', label: 'Warehouse', value: 'warehouse' },
          { type: 'input', label: 'Shipment#', value: 'shipmentNo' }
        ]
      },
      // 相关列表
      listTypeInfo: {
        holdStatusList: [
          { key: 'HOLD', value: 1 },
          { key: 'NORMAL', value: 2 }
        ],
        customerList: [
          { key: 'APPLE GROUP', value: 1 },
          { key: 'AMAZON GROUP', value: 2 }
        ]
      }
    }
  },
  methods: {
    handleSetLanguage() {
      if (this.$i18n.locale === 'en') {
        this.$i18n.locale = 'zhCN'
      } else {
        this.$i18n.locale = 'en'
      }
      this.$message.success('Switch Language Success')
    },
    handleSetLanguageTW() {
      if (this.$i18n.locale !== 'zhTW') {
        this.$i18n.locale = 'zhTW'
        this.$message.success('Switch Language Success')
      }
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apex-button',{staticStyle:{"margin-bottom":"10px"},attrs:{"type":"primary"},on:{"click":_vm.handleSetLanguage}},[_vm._v("切换中英文")]),_vm._v(" "),_c('apex-button',{staticStyle:{"margin-bottom":"10px","margin-left":"50px"},attrs:{"type":"primary"},on:{"click":_vm.handleSetLanguageTW}},[_vm._v("切換繁體")]),_vm._v(" "),_c('apex-filter',{attrs:{"lang":"en","query":_vm.filterInfo.query,"filter-list":_vm.filterInfo.list,"list-type-info":_vm.listTypeInfo},on:{"update:query":function($event){return _vm.$set(_vm.filterInfo, "query", $event)}}})],1)}
var staticRenderFns = []

  
    const democomponentExport = {
  data() {
    return {
      filterInfo: {
        query: {
          holdStatus: '',
          pol: '',
          pod: '',
          etd: '',
          eta: '',
          customer: '',
          hawbNo: '',
          warehouse: '',
          shipmentNo: ''
        },
        list: [
          { type: 'select', label: 'Hold Status', value: 'holdStatus', list: 'holdStatusList' },
          { type: 'input', label: 'POL', value: 'pol' },
          { type: 'input', label: 'POD', value: 'pod' },
          { type: 'date', label: 'ETD', value: 'etd', dateType: 'date' },
          { type: 'date', label: 'ETA', value: 'eta', dateType: 'datetime' },
          { type: 'select', label: 'Customer', value: 'customer', list: 'customerList' },
          { type: 'input', label: 'HAWB NO.', value: 'hawbNo' },
          { type: 'input', label: 'Warehouse', value: 'warehouse' },
          { type: 'input', label: 'Shipment#', value: 'shipmentNo' }
        ]
      },
      // 相关列表
      listTypeInfo: {
        holdStatusList: [
          { key: 'HOLD', value: 1 },
          { key: 'NORMAL', value: 2 }
        ],
        customerList: [
          { key: 'APPLE GROUP', value: 1 },
          { key: 'AMAZON GROUP', value: 2 }
        ]
      }
    }
  },
  methods: {
    handleSetLanguage() {
      if (this.$i18n.locale === 'en') {
        this.$i18n.locale = 'zhCN'
      } else {
        this.$i18n.locale = 'en'
      }
      this.$message.success('Switch Language Success')
    },
    handleSetLanguageTW() {
      if (this.$i18n.locale !== 'zhTW') {
        this.$i18n.locale = 'zhTW'
        this.$message.success('Switch Language Success')
      }
    }
  }
}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  